import { IFundRule } from '../rules/ifund-rule'
import { AbstractFilterHandlerResultModel } from './abstract-filter-handler-result-model'
import { FilterHandlerResultType } from './filter-handler-result-type.enum'
import { FundCategoryModel } from './fund-category-model'

export class RuleBaseFilterHandlerResultModel extends AbstractFilterHandlerResultModel {
  private readonly fundRule: IFundRule

  constructor(fundRule: IFundRule) {
    super()
    this.fundRule = fundRule
  }

  getAppliedFundRule(): IFundRule {
    return this.fundRule
  }

  getFilterHandlerResultType(): FilterHandlerResultType {
    return FilterHandlerResultType.ResultTypeRule
  }

  getFundGroupList(): FundCategoryModel[] {
    return []
  }
}
